import React from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import DonutChart from '@/pages/dashboard/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import {partnerResponses, stewardResponses} from './_invitationDeclineReasons';
import {useEventsContext} from "@/pages/dashboard/EventsContext";
import _ from "lodash";

export default function InvitationDeclinerYear(props) {
  const {subtitle} = props;
  const {filteredInvitations, isLoadingInvitations} = useEventsContext();

  if (isLoadingInvitations) {
    return (
      <ChartLoader
        title="Breakdown of who declined the invitation"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  // Create regex patterns for matching partner and steward decline reasons
  // These patterns are case-insensitive and properly escaped for regex
  const partnerRespRegex = partnerResponses.map(resp => new RegExp(_.escapeRegExp(resp), "i"));
  const stewardRespRegex = stewardResponses.map(resp => new RegExp(_.escapeRegExp(resp), "i"));

  // Initialize counters for partner and steward declines
  const counts = {partner: 0, steward: 0};

  // Iterate through all projects and their decline reasons
  for (const invitation of filteredInvitations) {
    // Check if the decline reason matches any partner response pattern
    const isPartner = partnerRespRegex.find(regex => regex.test(invitation.responseMessage));
    if (isPartner) counts.partner++;

    // Check if the decline reason matches any steward response pattern
    const isSteward = stewardRespRegex.find(regex => regex.test(invitation.responseMessage));
    if (isSteward) counts.steward++;
  }

  // Chart labels and data series
  const labels = ['Declined by Partner', 'Declined by Steward']
  const series = [counts.partner, counts.steward]

  // const series = requests.map(r => r.invitations.meta.totalCount);
  // const labels = requests.map(r => r.label);

  return (
    <DonutChart
      title="Breakdown of who declined the invitation"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.yellow['400']
      ]}
    />
  );
}
